import { RunStates } from '@/libs/signalR/vuexStore/store/state';
import ACTIONS from '../storeActions';

class BusinessLogicRunInfo {

  constructor(vue, runInfo, user) {
    this.vue = vue;
    this.runInfo = runInfo;
    this.user = user;
  }

  loadRunInfo(vue) {
    const self = this;

    const result = new Promise((resolve, reject) => {
      vue.$apiRequest.get('/RunDetails', null)
        /**
         * @property { WebAppRunDto } data
         */
        .then((data) => {
          vue.$store.dispatch(ACTIONS.SET_RUN_INFO, data);
          vue.$store.dispatch(ACTIONS.SIGNAL_R__SET_RUN_STATE, this.transformRunStateToEventType(data.status))
          self.runInfo = data;
          resolve(data);
        })
        .catch((error) => {
          console.log('error', error);
          reject(error);
        })
        .finally(() => {
        });
    });

    return result;
  }

  transformRunStateToEventType(runState) {
    // todo improve this based on new runStatus Values provided later
    if (!runState) return RunStates.Unknown;
    switch (runState) {
      case 1:
        return RunStates.RunStarted
      default:
        return RunStates.Unknown
    }
  }

  loadInterviews() {
    let promises = [];
    for (const exercise of this.vue.$store.state.runInfo.exercises) {
      if (exercise.interviewId) promises.push(this.loadInterview(exercise.interviewId))
    }
    const result = new Promise((resolve, reject) => {
      Promise.all(promises).finally(() => resolve());
    })
    return result;
  }

  loadInterview(interviewId) {
    const self = this;
    return new Promise((resolve, reject) => {
      self.vue.$apiRequest
        .get(`/Interviews/${interviewId}`)
        .then((data) => {
          // sort it here so that we can just use the sorted data later
          data.interviewCompetencies.sort((a, b) => a.orderIndex - b.orderIndex)
          data.interviewCompetencies.forEach((ic) => {
            ic.interviewQuestions.sort((a, b) => a.orderIndex - b.orderIndex)
          })
          self.vue.$store.dispatch(ACTIONS.PUSH_INTERVIEWS, data)
          resolve(data);
        })
        .catch((error) => {
          console.log('error', error);
          reject(error);
        })
    });
  }

  findObserverTeamId(runInfo, user) {
    // find observer team id
    for (const team of this.runInfo.teams) {
      for ( const member of team.members ) {
        if (member.id === this.user.userId) {
          return team.id
        }
      }
    }
    return null;
  }

  createObserverTimeTable(observerTeamId) {
    // Now sort the timetable for the current observer
    let observerTimeTable = [];
    // console.log('observer timetable')
    for (const c of this.runInfo.participants) {
      // console.log('c',c)
      const participant = {
        exercises: [],
        ...c,
      };

      for (const t of this.runInfo.appointments) {
        // console.log('t',t)
        if (t.teamIds.includes(observerTeamId)) {
          if (t.participantIds.includes(c.id) && t.exerciseId != null) {

            const thisExercise = this.runInfo.exercises.find((x) => x.id === t.exerciseId);

            // exercise observed isnt a thing anymore i think, it may have been changed to exerciseType?
            // if (thisExercise.observed === true) {
            participant.exercises.push({
              exerciseId: t.exerciseId,
              participantIds: t.participantIds,
              startTime: t.startTime,
              // room moved into the app run team
              // room: t.description,
              endTime: t.endTime,
              exercise: thisExercise,
            });
            // }
          }
        }
      }

      if (participant.exercises.length > 0) {
        // sort participantExercises based on sortOrder
        // there is no sortOrder anymore... Clear up
        // todo figure out how to sort them correctly - maybe based on time?
        //participant.exercises.sort((a, b) => a.exercise.sortOrder - b.exercise.sortOrder)
        observerTimeTable.push(participant);
      }

      observerTimeTable.sort((a, b) => {
        if (a.number > b.number) return 1;
        if (b.number > a.number) return -1;
        return 0;
      });
    }

    return observerTimeTable;
  }

  loadAllParticipantImages(vue) {
    let promises = [];

    for (const participant of this.runInfo.participants) {
      promises.push(this.loadParticipantImage(participant.id, vue));
    }

    const result = new Promise((resolve, reject) => {

      Promise.all(promises).finally(() => resolve());

    });

    return result;
  }

  loadParticipantImage(participantId, vue) {
    const self = this;
    const dummyImage = { id: participantId, data: 404 };

    const result = new Promise((resolve, reject) => {
      if (!vue) {
        return reject(new Error('No vue instance passed.'));
      }

      vue.$apiRequest.getBlob(`/candidates/${participantId}/picture`).then(async (image) => {
        if (!image) {
          vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, dummyImage);
          resolve(dummyImage);
        }

        const reader = new FileReader();
        reader.onload = function () {
          const blobBase64 = reader.result;
          // console.log('data url loaded', blobAsDataUrl)
          const participantImage = { id: participantId, data: blobBase64 };
          vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, participantImage);
          resolve(participantImage);
        };

        reader.readAsDataURL(image);

        return null;
      }).catch((e) => {
        vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, dummyImage);
        reject(e);
      });

      return null;
    });

    return result;
  }
}

export default BusinessLogicRunInfo;
